import i18nModule from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "@src/locales/en.json";
import de from "@src/locales/de.json";

export const I18N_NAMESPACE = "dqm";

/** Federation may return the shared module namespace instead of its default instance. */
export function resolveI18nInstance<T>(module: T): T {
  const candidate = module as { on?: unknown; default?: unknown };
  if (typeof candidate?.on === "function") return module;

  const unwrapped = candidate?.default;
  if (typeof (unwrapped as { on?: unknown } | undefined)?.on === "function") {
    return unwrapped as T;
  }
  return module;
}

const i18n = resolveI18nInstance(i18nModule);

if (!i18n.isInitialized) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        en: { [I18N_NAMESPACE]: en },
        de: { [I18N_NAMESPACE]: de },
      },
      defaultNS: I18N_NAMESPACE,
      fallbackLng: "en",
      interpolation: { escapeValue: false },
    });
} else {
  i18n.addResourceBundle("en", I18N_NAMESPACE, en, true, true);
  i18n.addResourceBundle("de", I18N_NAMESPACE, de, true, true);
}

export default i18n;
